// extracted by mini-css-extract-plugin
export var growableInput = "_9o-0";
export var tagContainer = "_9o-2";
export var textInput = "_9o-1";